/* Scroll reveal. See facecloths-motion.css for the why.
   [data-fc-reveal] elements (the free shipping line under the pack cards) are
   revealed on every page. The general fade-up is only switched on where the
   layout sets data-fc-reveal-page on <html>: the homepage, Buy now and
   product pages, never the cart, checkout path or wholesale portal. */
(function () {
  window.fcMotionReady = true;
  var root = document.documentElement;
  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.classList.remove('fc-motion');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.15 });

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  function start() {
    document.querySelectorAll('[data-fc-reveal]').forEach(function (el) { io.observe(el); });

    if (!root.hasAttribute('data-fc-reveal-page')) return;
    var picks = document.querySelectorAll(
      'main .shopify-section:not(:first-child) h2, main .fc-eyebrow, main .fc-fix__step, main .fc-fix__note'
    );
    var step = 0;
    picks.forEach(function (el) {
      // leave alone: headings the theme already animates, parallax pieces,
      // anything in the buy box, sliders, and whatever is already on screen
      if (el.matches('.js-split-text') || el.closest('.js-parallax, .fc-packs, product-form, .swiper, .splide, [data-fc-reveal]')) return;
      if (inView(el)) return;
      if (el.classList.contains('fc-fix__step')) {
        el.style.setProperty('--fc-reveal-delay', (step++ * 0.12) + 's');
      }
      el.setAttribute('data-fc-auto-reveal', '');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ===========================================================================
   HEARTS WHEN SOMETHING IS ADDED TO THE BAG (Elle, 2026-09-28: "so cute,
   implement that right now"). Approved from the mock-up in
   projects/website-refresh/engagement-mockups-2026-09-28/.

   The site adds to the bag from several places (product page, Glow viral "+",
   Routines, the ad landing page, the wholesale portal), each with its own
   code. Rather than touch each one, this watches for Shopify's answer to any
   /cart/add request and celebrates only when:
     - the add actually succeeded (no error status), and
     - a person tapped something in the last 8 seconds, so an automatic add
       such as shipping protection can never set it off on its own.
   Hearts burst from whatever was tapped; a small note says it worked.
   Reduced motion: the note only, no hearts.
   =========================================================================== */
(function () {
  if (!window.fetch || window.fcHeartsReady) return;
  window.fcHeartsReady = true;

  var lastTap = null, lastTapAt = 0, lastParty = 0;
  document.addEventListener('pointerdown', function (e) {
    var t = e.target.closest && e.target.closest('button, a, [role="button"], input[type="submit"], label');
    if (t) { lastTap = t; lastTapAt = Date.now(); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { lastTap = document.activeElement; lastTapAt = Date.now(); }
  }, true);

  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="C" d="M12 21s-7.5-4.6-9.6-9C.9 8.6 3 5 6.5 5c2.1 0 3.5 1.2 5.5 3.3C14 6.2 15.4 5 17.5 5 21 5 23.1 8.6 21.6 12c-2.1 4.4-9.6 9-9.6 9z"/></svg>';
  var COLOURS = ['#C25C7C', '#F2B9CB', '#B0355B', '#E8B9CA'];

  function note() {
    var n = document.getElementById('fc-bag-note');
    if (!n) {
      n = document.createElement('div');
      n.id = 'fc-bag-note';
      n.className = 'fc-bag-note';
      n.setAttribute('role', 'status');
      n.setAttribute('aria-live', 'polite');
      document.body.appendChild(n);
    }
    n.textContent = 'Added to your bag 💗';
    n.classList.remove('is-on'); void n.offsetWidth; n.classList.add('is-on');
    clearTimeout(n._t);
    n._t = setTimeout(function () { n.classList.remove('is-on'); }, 2000);
  }

  function hearts(from) {
    var r = from && from.isConnected ? from.getBoundingClientRect() : null;
    if (!r || !r.width) r = { left: window.innerWidth / 2 - 60, top: window.innerHeight - 120, width: 120 };
    for (var i = 0; i < 9; i++) {
      var h = document.createElement('span');
      h.className = 'fc-heart';
      h.innerHTML = HEART.replace('C', COLOURS[i % COLOURS.length]);
      var s = 14 + Math.random() * 12;
      h.style.width = h.style.height = s + 'px';
      h.style.left = (r.left + r.width * (0.2 + Math.random() * 0.6)) + 'px';
      h.style.top = r.top + 'px';
      h.style.setProperty('--dx', (Math.random() * 90 - 45) + 'px');
      h.style.setProperty('--rot', (Math.random() * 50 - 25) + 'deg');
      h.style.animationDelay = (i * 0.05) + 's';
      document.body.appendChild(h);
      setTimeout(function (el) { el.remove(); }.bind(null, h), 1700);
    }
  }

  function party() {
    if (Date.now() - lastTapAt > 8000) return;      // nobody tapped: an automatic add
    if (Date.now() - lastParty < 1500) return;      // one celebration per tap
    lastParty = Date.now();
    if (!still) hearts(lastTap);
    note();
  }

  var realFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = realFetch.apply(this, arguments);
    if (url.indexOf('/cart/add') === -1) return p;
    p.then(function (res) {
      if (!res || !res.ok) return;
      res.clone().json().then(function (d) { if (!d || !d.status) party(); }).catch(function () { party(); });
    }).catch(function () {});
    return p;
  };
})();

/* ===========================================================================
   CONFETTI EVERY TIME THE BAG OPENS (Elle, 2026-09-28: "Can you make that
   happen all the time whenever people go to the shopping bag?").
   Same two side cannons as the old free-box confetti in main-cart-items.liquid,
   which now stands aside (window.fcBagConfettiOn, set in theme.liquid).
   Fires when the slide-out bag opens and when the /cart page loads, but never
   for an empty bag. Nothing for people who ask for reduced motion.
   =========================================================================== */
(function () {
  if (window.fcConfettiReady) return;
  window.fcConfettiReady = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var last = 0;
  function confetti() {
    if (Date.now() - last < 1200) return;
    last = Date.now();
    var colours = ['#B0355B', '#E8B9CA', '#F7E1E8', '#9C5C74', '#FAEAEF', '#C25C7C'];
    var box = document.createElement('div');
    box.setAttribute('aria-hidden', 'true');
    box.className = 'fc-confetti';
    for (var i = 0; i < 52; i++) {
      var bit = document.createElement('span');
      var size = 6 + Math.random() * 7;
      var fromLeft = i % 2 === 0;
      bit.style.cssText =
        'width:' + size + 'px;height:' + (size * 1.6) + 'px;' +
        (fromLeft ? 'left:-3vw;' : 'right:-3vw;') +
        'top:' + (45 + Math.random() * 40) + 'vh;' +
        'background:' + colours[i % colours.length] + ';' +
        'border-radius:' + (Math.random() < 0.4 ? '50%' : '1px') + ';' +
        '--dx:' + ((30 + Math.random() * 55) * (fromLeft ? 1 : -1)) + 'vw;' +
        '--dy:' + (-10 - Math.random() * 45) + 'vh;' +
        '--rot:' + (360 + Math.random() * 720) + 'deg;' +
        'animation-duration:' + (1.6 + Math.random() * 1.4) + 's;' +
        'animation-delay:' + (Math.random() * 0.25) + 's';
      box.appendChild(bit);
    }
    document.body.appendChild(box);
    setTimeout(function () { box.remove(); }, 5000);
  }
  window.fcConfetti = confetti;

  function start() {
    // the slide-out bag: fires on the moment it gains "active"
    document.querySelectorAll('cart-drawer').forEach(function (d) {
      var open = d.classList.contains('active');
      new MutationObserver(function () {
        var now = d.classList.contains('active');
        if (now && !open && !d.classList.contains('is-empty')) {
          var inner = d.querySelector('.drawer__inner');
          if (!inner || !inner.classList.contains('is-empty')) confetti();
        }
        open = now;
      }).observe(d, { attributes: true, attributeFilter: ['class'] });
    });
    // the bag page itself
    if (/^\/cart\/?$/.test(location.pathname) && document.querySelector('[id^="CartItem-"], .cart-item')) {
      setTimeout(confetti, 250);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
